<template>
	<span>
		<v-tooltip top>
			<template v-slot:activator="{ on }">
				<span v-on="on">
					<v-btn
						icon
						small
						:disabled="!model.twofa"
						:class="$vuetify.breakpoint.smAndDown ? 'mx-1' : 'mx-0'"
						@click.stop="dialog = true">
						<v-icon :size="$vuetify.breakpoint.smAndDown ? 28 : 24" :color="model.twofa ? params.color : 'grey'">{{ params.icon }}</v-icon>
					</v-btn>
				</span>
			</template>
			<span>{{ model.twofa ? params.text : 'Verifica in due passaggi non configurata' }}</span>
		</v-tooltip>

		<v-dialog v-model="dialog" max-width="600" persistent>
			<v-card class="background-2 round-card">
				<v-card-title class="pa-3">
					<p class="pl-2 pl-xl-3">Reset verifica in due passaggi</p>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="pt-4 body-2" style="min-height: 100px;">
					La verifica in due passaggi di <strong>{{ model.name }}</strong> verrà azzerata e le sue sessioni aperte
					verranno chiuse. Vale per tutte le aziende a cui l'utente accede.
					<br><br>
					Se la verifica è obbligatoria, al prossimo accesso l'utente dovrà inquadrare un nuovo codice QR con
					l'app di autenticazione.
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text color="primary" :disabled="loading" @click="dialog = false">Annulla</v-btn>
					<v-btn text color="info" :loading="loading" @click="reset">Conferma</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</span>
</template>

<script>
export default {
	name: 'portal-reset-two-factor',
	props: {
		model: Object,
		params: Object,
		button: Object
	},
	data() {
		return {
			dialog: false,
			loading: false
		}
	},
	methods: {
		async reset() {
			this.loading = true
			try {
				const resp = await this.axios.post('portalusers-reset2fa/' + this.model.id)
				if (resp.data.success) {
					// Si ricarica la lista: un utente con piu' aziende ha una riga per
					// azienda, e il reset vale per tutte
					this.$eventBusUtility.$emit('refreshTable_portalusers')
					this.$store.commit('setSnackbar', {
						timeout: 4000,
						text: resp.data.message,
						value: true,
						color: 'success'
					})
				}
			} catch (e) {
				// errore gia' segnalato dall'interceptor
			} finally {
				this.loading = false
				this.dialog = false
			}
		}
	}
}
</script>
